<template>
  <div v-wechat-title="title" style="height:100%">
    {{title}}-{{this.$route.query.surgery_id}}
  </div>
</template>
<script>
export default {
    name: `RecoveryCharge`,
    props: {

    },
    data() {
        return {
            title: `复苏计费`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Surgery/RecoveryCharge/Index.vue